import { render, staticRenderFns } from "./form-detail.vue?vue&type=template&id=1dbbe6d2&"
import script from "./form-detail.vue?vue&type=script&lang=js&"
export * from "./form-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports